import api from './api';

export const supportService = {
  // Create a new support ticket
  createTicket: async (ticketData) => {
    const response = await api.post('/support/tickets', ticketData);
    return response.data;
  },

  // Get all tickets for the current user
  getMyTickets: async () => {
    const response = await api.get('/support/tickets');
    return response.data;
  },

  // Get a specific ticket with messages
  getTicket: async (ticketId) => {
    const response = await api.get(`/support/tickets/${ticketId}`);
    return response.data;
  },

  // Add a message to a ticket
  addMessage: async (ticketId, message) => {
    const response = await api.post(`/support/tickets/${ticketId}/messages`, { message });
    return response.data;
  },

  // Get rate limits for the user
  getRateLimits: async () => {
    const response = await api.get('/support/limits');
    return response.data;
  },
};

export const TICKET_CATEGORIES = [
  { value: 'ORDER', label: 'Order Related' },
  { value: 'PRODUCT', label: 'Product Inquiry' },
  { value: 'SHIPPING', label: 'Shipping & Delivery' },
  { value: 'REFUND', label: 'Returns & Refunds' },
  { value: 'FEEDBACK', label: 'Feedback & Reviews' },
  { value: 'OTHER', label: 'Other' },
];

export const TICKET_STATUS = {
  OPEN: { label: 'Open', color: '#3b82f6' },
  IN_PROGRESS: { label: 'In Progress', color: '#f59e0b' },
  AWAITING_CUSTOMER: { label: 'Awaiting Response', color: '#8b5cf6' },
  RESOLVED: { label: 'Resolved', color: '#10b981' },
  CLOSED: { label: 'Closed', color: '#6b7280' },
};
